export default "__VITE_ASSET__DQ_f5jmu__"